var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('codemirror',{ref:`cm-${_vm.randomId}`,attrs:{"value":_vm.sql,"options":_vm.options},on:{"input":_vm.inputAction}})
}
var staticRenderFns = []

export { render, staticRenderFns }